import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import Logo from "../../../assets/logos/18.svg"
const Footer = () => {
  return (
    <footer className="_fMain_l1A_">
      <div className="_fCont_m2B_">
        {/* Column 1: Brand */}
        <div className="_fCol_n3C_ _bCol_q6F_">
        <img src={Logo} className="_brandLogo_q0A_ footer-logo-img"  /> 
          <p className="_fMission_s8H_">
            Your shopping, a donation. Support your community with every local
            purchase.
          </p>
        </div>

        {/* Column 2: Get Started */}
        <div className="_fCol_n3C_" style={{ marginLeft: "5%" }}>
          <h4 className="_fHeading_p5E_">Get Started</h4>
          <ul className="_fLinks_o4D_">
            <li>
              <Link to="/how-it-works">How It Works</Link>
            </li>
            <li>
              <Link to="/get-app">Catalog</Link>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
          </ul>
        </div>

        {/* Column 3: Join Us */}
        <div className="_fCol_n3C_">
          <h4 className="_fHeading_p5E_">Join Us</h4>
          <ul className="_fLinks_o4D_">
            <li>
              <Link to="/sellers">For Sellers</Link>
            </li>
            <li>
              <Link to="/community">For Communities</Link>
            </li>
            <li>
              <Link to="/get-app">Get the App</Link>
            </li>
          </ul>
        </div>

        {/* Column 4: Company */}
        <div className="_fCol_n3C_">
          <h4 className="_fHeading_p5E_">Company</h4>
          <ul className="_fLinks_o4D_">
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/sow">Statement of Work</Link>
            </li>
            <li>
              <Link to="/sop">Operating Procedures</Link>
            </li>
          </ul>
        </div>

        {/* Column 5: Support */}
        <div className="_fCol_n3C_">
          <h4 className="_fHeading_p5E_">Support</h4>
          <ul className="_fLinks_o4D_">
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <Link to="/support">Support Center</Link>
            </li>
            <li>
              <Link to="/support-handbook">Support Handbook</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="_fSub_t9I_">
        <p>© {new Date().getFullYear()} Vanidya. All Rights Reserved.</p>
        <div className="_fSubLinks_u0J_">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span>|</span>
          <Link to="/terms-and-conditions">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
